module.exports = __webpack_public_path__ + "static/percorso-p-logo-blue-272af22f0608b8da4001ae67c01f3ba7.png";